const axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default function InitAboBooking() {
    const container = document.getElementById('abo-booking');

    if (!container)
        return;

    const bookableItems = container.querySelectorAll('input[name*="cart"]');
    const sumElement = document.getElementById('price');
    const totalPriceElement = document.getElementById('total-price');
    const discountElement = document.getElementById('discount');
    const accordionToggles = container.querySelectorAll('.accordion-toggle');

    bookableItems.forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
            console.log('change');
            getTotalPrice(function (data) {
                sumElement.innerHTML = (Number(data.price)).toLocaleString('de-DE', { minimumFractionDigits: 2 });
                discountElement.innerHTML = (Number(data.discount)).toLocaleString('de-DE', { minimumFractionDigits: 2 });
                totalPriceElement.innerHTML = (Number(data.total)).toLocaleString('de-DE', { minimumFractionDigits: 2 });
            });
        });
    });

    // if there is only one accordion item: open it
    if (accordionToggles?.length == 1)
        accordionToggles[0]?.click();
}

function getTotalPrice(callback) {

    axios.post('/abos/price', {
        cart: getCartItems()
    })
        .then((response) => {
            if (typeof callback == 'function')
                callback(response.data);
        })
        .catch((error) => {
            console.error(error);
        });
}

function getCartItems() {
    const inputs = document.querySelectorAll(`#abo-booking input[name*="cart"]`);
    let inputIds = [];

    inputs.forEach((input) => {
        if (input.checked)
            inputIds.push(input.id);
    });

    return inputIds;
}